document.addEventListener('DOMContentLoaded', function() {
  const cacheKey = `?cacheKey=${new Date().getTime()}`;
  fetch(`/_data/jobs.json${cacheKey}`)
    .then(function(response) { return response.json(); })
    .then(data => {
      const jobsContainer = document.getElementById('jobsData');
      const moreJobsLink = document.getElementById('moreJobsLink');
      if (jobsContainer) {
        const now = new Date();
        data = data.filter(job => !job.applyDeadline || new Date(job.applyDeadline) > now);
        const jobCount = data.length;
        if (data.length === 0) {
          const mediaReleases = document.getElementById('mediaReleases');
          if (mediaReleases) {
            mediaReleases.classList.remove('d-none');
          }
        } else {
          const careers = document.getElementById('careers');
          if (careers) {
            careers.classList.remove('d-none');
          }
        }

        if (jobCount > 2) {
            data = data.sort((a, b) => {
            if (!a.applyDeadline) return 1;
            if (!b.applyDeadline) return -1;
            return new Date(a.applyDeadline) - new Date(b.applyDeadline);
            }).slice(0, 2);
          if (moreJobsLink) {
            moreJobsLink.classList.remove('d-none');
          }
        } else {
          data = data.sort((a, b) => {
            if (!a.applyDeadline) return -1;
            if (!b.applyDeadline) return 1;
            return new Date(a.applyDeadline) - new Date(b.applyDeadline);
          });
        }

        data.forEach(job => {
            const colElement = document.createElement('div');
            if (jobCount === 1) {
              colElement.classList.add('col-12', 'mb-4');
            } else if (jobCount === 2) {
              colElement.classList.add('col-12', 'col-lg-6', 'mb-4');
            } else if (jobCount >= 3) {
              colElement.classList.add('col-12', 'col-lg-6', 'col-lg-4', 'mb-4');
            }

            const jobElement = document.createElement('div');
            colElement.appendChild(jobElement);

            const cardBodyElement = document.createElement('div');
            jobElement.appendChild(cardBodyElement);

            const titleElement = document.createElement('h3');
            titleElement.classList.add('h5', 'card-title');
            const titleSpan = document.createElement('span');
            titleSpan.textContent = job.title;
            titleElement.appendChild(titleSpan);
            cardBodyElement.appendChild(titleElement);

            const level = document.createElement('p');
            level.classList.add('small');
            level.textContent = `${job.level}`;
            cardBodyElement.appendChild(level);

            const descElement = document.createElement('p');
            descElement.classList.add('balance-text', 'mw-70');
            descElement.textContent = job.desc;
            cardBodyElement.appendChild(descElement);

            if (job.customClose) {
              const customCloseElement = document.createElement('p');
              customCloseElement.classList.add('small');
              customCloseElement.textContent = job.customClose;
              cardBodyElement.appendChild(customCloseElement);
            } else {
              const deadlineElement = document.createElement('p');
              deadlineElement.classList.add('small');
              const applyDeadline = new Date(job.applyDeadline);
              const options = { month: 'short', day: 'numeric', year: 'numeric' };
              const monthNames = ["Jan.", "Feb.", "March", "April", "May", "June", "July", "Aug.", "Sep.", "Oct.", "Nov.", "Dec."];
              const formattedDate = applyDeadline.toLocaleDateString('en-US', options).replace(/(\w+)\s/, function(_, p1) { return monthNames[new Date(`${p1} 1, 2000`).getMonth()] + ' '; });
              deadlineElement.textContent = `Apply by ${formattedDate}.`;
              cardBodyElement.appendChild(deadlineElement);
            }

            const cardFooterElement = document.createElement('div');
            cardFooterElement.classList.add('card-footer', 'small');

            const openToElement = document.createElement('span');
            openToElement.textContent = 'This job is open to: ';

            if (job.publicLink) {
            const publicLinkElement = document.createElement('a');
            publicLinkElement.setAttribute('rel', 'nofollow');
            publicLinkElement.href = job.publicLink;
            publicLinkElement.textContent = 'the public';
            publicLinkElement.target = '_blank';
            openToElement.appendChild(publicLinkElement);

            openToElement.appendChild(document.createTextNode(' and '));
            }

            const statusCandidateLinkElement = document.createElement('a');
            statusCandidateLinkElement.setAttribute('rel', 'nofollow');
            statusCandidateLinkElement.href = job.statusCandidateLink;
            statusCandidateLinkElement.textContent = 'status candidates.';
            statusCandidateLinkElement.target = '_blank';
            openToElement.appendChild(statusCandidateLinkElement);

            cardFooterElement.appendChild(openToElement);

            jobElement.appendChild(cardFooterElement);

            jobsContainer.appendChild(colElement);
        });
      }

    })
    .catch(error => console.error('Error fetching jobs:', error));
});
